import { Component, OnInit }                      from '@angular/core';
//**************************************************************
// Router
import { Router }                                 from '@angular/router';
//**************************************************************
// Router
import { ActivatedRoute }                         from '@angular/router';
//**************************************************************
// List Structures
import { menuitem, logininfo, liststructures }    from '../../classinjection/app.liststructures';
@Component({
  selector: 'app-comadmin',
  templateUrl: './comadmin.component.html',
  styleUrls: ['./comadmin.component.css']
})


export class ComadminComponent implements OnInit 
  {
    //**************************************************************
    navigation: menuitem[];

    isDrawerOpen: boolean = true;
    isCloseOutsideClick: boolean = false;

    selectedOpenMode: string    = 'shrink';
    selectedPosition: string    = 'left';
    selectedRevealMode: string  = 'slide';


    // Screen width & Height
    windowWidth: any;
    windowHeight: any;
    widowbottomoffset: number = 50;
    formheight: number;
    //**************************************************************
    constructor (
                  private menuselect: liststructures,
                  private routernavigate: Router,
                  private _Activatedroute:ActivatedRoute
                ) 
      {

        this.navigation = this.menuselect.getmenuListAdmin();

      }
    //**************************************************************
    ngOnInit(): void 
      {

      // Screen Width & Height
      this.windowWidth          = window.innerWidth;
      this.windowHeight         = window.innerHeight - this.widowbottomoffset;
      //****************************************************************
      this.formheight =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));   
      console.log( this.formheight )
      }
    //**************************************************************
    menutargetclick( event: any)
      {
        // Menu Selected
        var menuselect = event.itemData.id;
        var routepath: string;
     
        switch ( menuselect )
          {
            //**************************************************************  
            case 500:  {
                          routepath    = 'propdocadmin/' + this.windowHeight + '/faqadmin/' + + this.windowHeight
                          this.routernavigate.navigate( [routepath], { replaceUrl: true })
                          break;
                        }
            //**************************************************************
            case 510:  {
                          console.log( 'x:' + menuselect )
                          break;
                        }   
            //**************************************************************     
            case 520:  {
                          console.log( 'y:' + menuselect )
                          break;
                        }   
            //**************************************************************       
          }
        
      }
    //**************************************************************
  }
